module.exports = __webpack_public_path__ + "static/media/019.4f38fc8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/019.jpg
// module id = 316
// module chunks = 0